enum IntegrationType {
  TAPIO = 'tapio',
}
export { IntegrationType };
